import { usePermissionCheck } from "@/hooks/use-permissions.hook.ts";
import { useTitle } from "@/hooks/use-title.hook.ts";
import { WorkflowLibraryFoldersView } from "@/pages/workflows/WorkflowLibraryFoldersView.tsx";
import { WorkflowLibraryListView } from "@/pages/workflows/WorkflowLibraryListView.tsx";
import analyticsService, { analyticEvents } from "@/services/analytics-service.ts";
import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router-dom";
import { useEffectOnce } from "react-use";

export const WorkflowLibrary = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id?: string }>();
  const { canEditWorkflows } = usePermissionCheck();

  useTitle(t("workflow:workflows"));

  useEffectOnce(() => {
    analyticsService.trackEvent(analyticEvents.workflows.viewed);
  });

  if (!canEditWorkflows) {
    return <Navigate to={"/workflows/executions"} replace />;
  }

  if (id == undefined) {
    return <WorkflowLibraryFoldersView />;
  }

  return <WorkflowLibraryListView />;
};
